var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DateTime } from 'luxon';
import { useLocation } from '../../hooks';
import { gql } from '@apollo/client';
import { useAddShiftMutation } from '@amzn/atoz-shiftapp-types';
import { hasDropPenalty, isUndroppable, BIAnalytics, useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { onAddShiftUpdate } from '../../features/OpportunityFlowModal/utils';
import { getOpportunitiesRefetchQuery, getScheduleRefetchQuery } from '../../utils';
import { logger } from '@amzn/atoz-shiftapp-metrics';
export var ADD_SHIFT_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation AddShift($shiftOpportunityId: AddShiftInput!) {\n        addShift(input: $shiftOpportunityId)\n    }\n"], ["\n    mutation AddShift($shiftOpportunityId: AddShiftInput!) {\n        addShift(input: $shiftOpportunityId)\n    }\n"])));
function onAddShiftWrapper(_a) {
    var shiftOpportunity = _a.shiftOpportunity, onAddShift = _a.onAddShift, onHasDropPenalty = _a.onHasDropPenalty, onNoDropPenalty = _a.onNoDropPenalty;
    var dropDeadline = shiftOpportunity.dropDeadline, penaltyStartTime = shiftOpportunity.penaltyStartTime, type = shiftOpportunity.type, end = shiftOpportunity.shift.timeRange.end;
    var shiftEnd = DateTime.fromISO(end);
    var penaltyDeadline = penaltyStartTime
        ? DateTime.fromISO(penaltyStartTime)
        : undefined;
    var undroppableOrDropPenalty = isUndroppable(dropDeadline) ||
        hasDropPenalty({
            shiftEndTime: shiftEnd,
            penaltyStartTime: penaltyDeadline
        });
    if (onHasDropPenalty && undroppableOrDropPenalty) {
        onHasDropPenalty();
        return;
    }
    if (onNoDropPenalty) {
        onNoDropPenalty();
    }
    onAddShift();
}
export function useAddShiftWrapper(_a) {
    var _this = this;
    var shiftOpportunity = _a.shiftOpportunity, onHasDropPenalty = _a.onHasDropPenalty, onNoDropPenalty = _a.onNoDropPenalty, onCompleted = _a.onCompleted, onError = _a.onError;
    var _b = useAssociateContext(), associateInfo = _b.associateInfo, features = _b.features;
    var pathname = useLocation().pathname;
    var _c = useAddShiftMutation({
        variables: {
            // shiftOpportunity.id will be defined when mutation actually fires
            shiftOpportunityId: {
                shiftOpportunityId: (shiftOpportunity === null || shiftOpportunity === void 0 ? void 0 : shiftOpportunity.id) || ''
            }
        },
        update: function (cache) {
            onAddShiftUpdate(cache);
        },
        refetchQueries: __spreadArray(__spreadArray([], getOpportunitiesRefetchQuery(pathname, features.findShiftsAPICallRedesign), true), getScheduleRefetchQuery(pathname), true),
        onCompleted: function () {
            var _a;
            if ((_a = shiftOpportunity === null || shiftOpportunity === void 0 ? void 0 : shiftOpportunity.incentivePay) === null || _a === void 0 ? void 0 : _a.payModifiers)
                logger.info('Shift with PayBreakdown incentives claimed', {
                    shiftId: shiftOpportunity === null || shiftOpportunity === void 0 ? void 0 : shiftOpportunity.id,
                    payModifiers: shiftOpportunity.incentivePay.payModifiers
                });
            onCompleted();
        },
        onError: function (error) {
            client.refetchQueries({
                include: __spreadArray([], getOpportunitiesRefetchQuery(pathname, features.findShiftsAPICallRedesign), true)
            });
            BIAnalytics.addShiftFailure((shiftOpportunity === null || shiftOpportunity === void 0 ? void 0 : shiftOpportunity.shift.id) || '', DateTime.local().toISO(), error.message);
            onError(error);
        }
    }), onAddShift = _c[0], _d = _c[1], loading = _d.loading, error = _d.error, client = _d.client;
    return {
        onAddShift: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onAddShiftWrapper({
                            onAddShift: onAddShift,
                            onHasDropPenalty: onHasDropPenalty,
                            onNoDropPenalty: onNoDropPenalty,
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            shiftOpportunity: shiftOpportunity
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        loading: loading,
        error: error
    };
}
var templateObject_1;
